import { useMutation, useQueryClient } from '@tanstack/react-query';

import { putTagsOnOfferingByOfferingId } from '@arrived/api_v2';
import { Offering, TagsViaOfferingPutRequest } from '@arrived/models';

import { offeringKeyFn } from '../offerings';
import { UseMutationOptions } from '../queries.utils';

export function usePutTagsOnOfferingByOfferingIdMutation(
  options?: UseMutationOptions<Offering, TagsViaOfferingPutRequest>
) {
  const queryClient = useQueryClient();

  return useMutation((tagsViaOfferingPutRequest) => putTagsOnOfferingByOfferingId(tagsViaOfferingPutRequest), {
    ...options,
    onSuccess: (data, variables, context) => {
      const { id: offeringId } = data;

      queryClient.invalidateQueries(offeringKeyFn(offeringId));

      options?.onSuccess?.(data, variables, context);
    },
  });
}
